import React, { Component } from "react";
import AreaForm from "./AreaForm.jsx";
import AttendanceForm from "./AttendanceForm.jsx";
import AttendanceRuleForm from "./AttendanceRuleForm.jsx";
import CompanyForm from "./CompanyForm.jsx";
import DepartmentForm from "./DepartmentForm.jsx";
import EmployeeTypeForm from "./EmployeeTypeForm.jsx";
import HolidaysForm from "./HolidaysForm.jsx";
import PagIbigForm from "./PagIbigForm.jsx";
import PayscaleForm from "./PayscaleForm.jsx";
import PerformanceForm from "./PerformanceForm.jsx";
import PHICForm from "./PHICForm.jsx";
import PositionForm from "./PositionForm.jsx";
import SSSForm from "./SSSForm.jsx";
import IncomeTaxForm from "./IncomeTaxForm.jsx";
import PayLevelForm from "./PayLevelForm.jsx";

class DatabaseForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            collection: null,
            instanceId: null,
            employeeId: null
        }
    }

    componentDidMount() {
        const { match } = this.props;
        if(match.params.collection) {
            if (match.params.action === "create" && match.params.collection === "attendance" && match.params.id) {
                this.setState({
                    collection: match.params.collection,
                    employeeId: match.params.id && match.params.id
                })
            } else {
                this.setState({
                    collection: match.params.collection,
                    instanceId: match.params.id && match.params.id
                })
            }
            
        }
    }

    goBack = () => {
        this.props.history.goBack()
    }

    goToList = (collection, id, type) => {
        let link;
        if (type === 'date') {
            link = `/database/list/${collection}?date=${id}`
        } else if (type) {
            link = `/database/list/${collection}?date=${id}&location=${type}`
        } else if (collection && id) {
            link = `/database/list/${collection}/${id}`
        } else if (collection) {
            link = `/database/list/${collection}`
        } else {
            link = `/database/list`
        }
        this.props.history.push(link)
    }

    render() {

        const { 
            collection,
            instanceId,
            employeeId
        } = this.state;

        return (
        <div className="content">
            {collection === "area" &&
                <AreaForm instanceId={instanceId} goToList={this.goToList} />
            }
            {collection === "attendance" &&
                <AttendanceForm instanceId={instanceId} employeeId={employeeId} goToList={this.goToList} goBack={this.goBack}/>
            }
            {collection === "attendance-rule" &&
                <AttendanceRuleForm instanceId={instanceId} employeeId={employeeId} goToList={this.goToList} />
            }
            {collection === "company" &&
                <CompanyForm instanceId={instanceId} goToList={this.goToList} />
            }
            {collection === "department" &&
                <DepartmentForm instanceId={instanceId} goToList={this.goToList}/>
            }
            {collection === "employeeType" &&
                <EmployeeTypeForm instanceId={instanceId} goToList={this.goToList} />
            }
            {collection === "holidays" &&
                <HolidaysForm instanceId={instanceId} goToList={this.goToList} />
            }
            {collection === "payscale" &&
                <PayscaleForm instanceId={instanceId} goToList={this.goToList} goBack={this.goBack}/>
            }
            {collection === "performance" &&
                <PerformanceForm instanceId={instanceId} goToList={this.goToList} />
            }
            {collection === "phic" &&
                <PHICForm instanceId={instanceId} goToList={this.goToList} goBack={this.goBack}/>
            }
            {collection === "position" &&
                <PositionForm instanceId={instanceId} goToList={this.goToList} />
            }
            {collection === "sss" &&
                <SSSForm instanceId={instanceId} goToList={this.goToList} goBack={this.goBack}/>
            }
            {collection === "pag-ibig" &&
                <PagIbigForm instanceId={instanceId} goToList={this.goToList} goBack={this.goBack}/>
            }
            {collection === "income-tax" &&
                <IncomeTaxForm instanceId={instanceId} goToList={this.goToList} />
            }
            {collection === "pay-level" &&
                <PayLevelForm instanceId={instanceId} goToList={this.goToList} />
            }
        </div>
        );
    }
}

export default DatabaseForm;
